import { useMutation } from '@tanstack/react-query';
import { WithEnterpriseId } from '@mews-commander/types';
import { SmsUsaBrandRegistrationAddParameters, useRepositoryRegistry } from '@mews-commander/data-access';
import { lt, showSuccessAlert, useGainsightService } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { reportConfigurationError } from '../../../../actions';

interface UseSmsUsaBrandRegistrationAddOptions extends WithEnterpriseId {
    onSuccess: () => void;
}

export const useSmsUsaBrandRegistrationAdd = ({ enterpriseId, onSuccess }: UseSmsUsaBrandRegistrationAddOptions) => {
    const dispatch = useCommanderThunkDispatch();
    const gainsightService = useGainsightService();

    const { smsUsaBrandRegistration } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (params: SmsUsaBrandRegistrationAddParameters) => smsUsaBrandRegistration.add(params),
        onSuccess: () => {
            showSuccessAlert({ description: lt('FormSubmitted') });
            gainsightService.trackEvent('SmsUsaBrandRegistrationSubmitSuccess');
            onSuccess();
        },
        onError: (error) => {
            if (error instanceof Error) {
                dispatch(reportConfigurationError({ error, extra: { enterpriseId } }));
            }
        },
    });
};
